export const initialState = {
  selectedSchedule: null,
  infoSchedule: null,
  members: null,
  supervisors: null,
  drawerState: {
    users: false,
    supervisors: false,
  },
  schedules: null,
  loading: false,
  error: null,
};

export const ACTIONS = {
  SET_SELECTED_SCHEDULE: 'SET_SELECTED_SCHEDULE',
  SET_INFO_SCHEDULE: 'SET_INFO_SCHEDULE',
  SET_MEMBERS: 'SET_MEMBERS',
  SET_SUPERVISORS: 'SET_SUPERVISORS',
  TOGGLE_DRAWER: 'TOGGLE_DRAWER',
  SET_SCHEDULES: 'SET_SCHEDULES',
  SET_LOADING: 'SET_LOADING',
  SET_ERROR: 'SET_ERROR',
};

export const scheduleListReducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.SET_SELECTED_SCHEDULE: {
      return { ...state, selectedSchedule: action.payload };
    }

    case ACTIONS.SET_INFO_SCHEDULE: {
      return { ...state, infoSchedule: action.payload };
    }

    case ACTIONS.SET_MEMBERS: {
      return { ...state, members: action.payload };
    }

    case ACTIONS.SET_SUPERVISORS: {
      return { ...state, supervisors: action.payload };
    }

    case ACTIONS.TOGGLE_DRAWER: {
      const drawerState = {
        ...state.drawerState,
        [action.payload]: !state.drawerState[action.payload],
      };
      return { ...state, drawerState };
    }

    case ACTIONS.SET_SCHEDULES: {
      return { ...state, schedules: action.payload };
    }

    case ACTIONS.SET_LOADING: {
      return { ...state, loading: action.payload };
    }

    case ACTIONS.SET_ERROR: {
      return { ...state, error: action.payload };
    }

    default: {
      return state;
    }
  }
};
